import { Injectable } from '@angular/core';
import { IFile, IViewerConfig } from '@devinforius/i-viewer';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class IViewerConfigService {
  /**
   * Initialise la configuration PDF avec l'Adobe Client ID depuis la config globale
   */
  initializePdfViewerConfig(): IViewerConfig {
    const config = new IViewerConfig();
    config.clientId = environment.adobeClientId;
    config.embedMode = 'FULL_WINDOW';
    config.defaultViewMode = 'FIT_PAGE';
    config.showDownloadPDF = false;
    config.showPrintPDF = false;
    config.showAnnotationTools = false;
    config.showThumbnails = true;
    config.showBookmarks = false;
    config.showZoomControl = true;
    config.enableAnnotationAPIs = false;
    config.includePDFAnnotations = false;
    config.enableLinearization = true;
    config.enableFormFilling = true;

    return config;
  }

  public getFileFromBlob(blobViewer: any): IFile | null {
    if (!blobViewer) {
      return null;
    }

    return {
      src: blobViewer,
      extension: 'pdf',
      title: 'preview.pdf',
    };
  }
}
